import _ from 'underscore';
import HotelMetricsColumns from '../common-columns/hotel-metrics-columns';

export function getName({
  CampaignId, // actually sub account id
  // AdGroupId, // actually hotel group id
}) {
  if (CampaignId) {
    return 'HotelIdGrid';
  }
  return 'AllSubAccountHotelIdGrid';
}

export function getColumnsMetadata() {
  return _.defaults({
    Bid: ['Bid', 'BidSource'],
    BidMultipliers: ['BidMultipliers', 'BidMultiplierSource'],
  }, HotelMetricsColumns);
}

export function getPage() {
  return 'HotelCenter';
}

export function getRoute() {
  return 'overview/grid-chooser-item-hotel-id';
}
